import isProd from '../constants/isProd'

const localStorage = isProd ? window.localStorage : []

export default localStorage
